import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { ToastrService } from 'ngx-toastr';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { FormGroup, FormControl, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { PASSWORD_MIN_LENGTH, PASSWORD_MAX_LENGTH, PASSWORD_PATTERN } from 'src/app/shared/password-strength/password-requirements';

@Component({
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.css']
})
export class ChangepasswordComponent implements OnInit {

  changePasswordForm: FormGroup;
  successMessage: string;
  errorMessage: string;
  isLoading: boolean;
  code: string;
  showOldPassword = false;
  showPassword = false;
  showCPassword = false;

  constructor(private activatedrouter: ActivatedRoute, private resetService: UseraccessserviceService, private toastr: ToastrService, private router: Router, private headerinfo: ComponentheaderService) {
    this.headerinfo.setHeaderDisplay('Change Password', [], []);

    this.code = this.activatedrouter.snapshot.queryParams.code;

    this.changePasswordForm = new FormGroup({
      password: new FormControl('', [
        Validators.required,
        Validators.minLength(PASSWORD_MIN_LENGTH),
        Validators.maxLength(PASSWORD_MAX_LENGTH),
        Validators.pattern(PASSWORD_PATTERN)
      ]),
      cpassword: new FormControl('', [Validators.required, this.passwordMatchValidator()]),
    });

    // no reset code means the user is changing a password they already know,
    // so the current one is required
    if (!this.code) {
      this.changePasswordForm.addControl('oldpassword', new FormControl('', [Validators.required]));
    }

    this.changePasswordForm.get('password')?.valueChanges.subscribe(() => {
      this.changePasswordForm.get('cpassword')?.updateValueAndValidity();
    });
  }

  passwordMatchValidator(): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      if (!group.value)
        return null;

      const password = this.changePasswordForm.get('password')?.value;
      const confirm = group.value;
      if (!password || !confirm) return null;
      return password === confirm ? null : { passwordMismatch: true };
    }
  }

  ngOnInit(): void {
    this.headerinfo.setPageTitle('Change Password');
  }


  async OnSubmit() {
    if (!this.changePasswordForm.valid) {
      return;
    }

    const newPassword = this.changePasswordForm.get('password').value;
    const oldPassword = this.changePasswordForm.get('oldpassword')?.value;

    this.isLoading = true;

    const notifyPasswordNotGloballyChanged = (data: any) => {
      if(data.topLevelUserExists){
        this.toastr.warning("Please note that the password change only applies to the account for this school", undefined, { timeOut: 0, closeButton: true});
      }
    }
    try{
      if(!this.code){//that means this is coming from change password
        const data: any = await this.resetService.passwordupdate(newPassword, oldPassword).toPromise().finally(() => { this.isLoading = false });
        if (data) {
          this.toastr.success("Password Reset Successful");
          notifyPasswordNotGloballyChanged(data);
          this.router.navigate(['/user/dashboard']);
        }
      }
      else{//that means the user got here by clicking the forgot password link
        const data: any = await this.resetService.forgotPasswordReset(this.code, newPassword).toPromise().catch((err) => { console.log(err) }).finally(() => { this.isLoading = false });
        if (data) {
          this.toastr.success("Password Reset Successful");
          notifyPasswordNotGloballyChanged(data);
          this.router.navigate(['/access/login']);
        }
      }
    }
    catch(err){
      console.log(err);
      this.toastr.error("Error While Resetting password");
    }
  }


}
